module.exports = __webpack_public_path__ + "img/404EN.37f0f2f0.png";